<!-- HERO -->
<section class="hero">
  <div class="hero-bg-layers">
    <div class="hero-bg-image"
         *ngFor="let slide of heroSlides; let i = index"
         [class.active]="currentSlide === i"
         [style.background-image]="'url(' + slide.image + ')'"></div>
  </div>
  <div class="hero-overlay"></div>
  <div class="hero-content">

    <!-- Slides de texto rotativos -->
    <div class="hero-slides">
      <div class="hero-slide"
           *ngFor="let slide of heroSlides; let i = index"
           [class.active]="currentSlide === i">
        <div class="hero-badge">
          <span></span>{{ slide.badge }}
        </div>
        <h1>
          <ng-container *ngFor="let linea of slide.titulo; let last = last">{{ linea }}<br *ngIf="!last"></ng-container>
        </h1>
        <p class="hero-desc">{{ slide.descripcion }}</p>
        <a *ngIf="slide.external" [href]="slide.ctaLink" target="_blank" rel="noopener" class="hero-cta">
          {{ slide.ctaLabel }}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </a>
        <a *ngIf="!slide.external" [routerLink]="slide.ctaLink" class="hero-cta">
          {{ slide.ctaLabel }}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </a>
      </div>
    </div>

    <!-- TARJETA RASTREO -->
    <div class="tracking-card">
      <label for="rastreo-hero">Rastreo de Pedido</label>
      <form class="tracking-form" [formGroup]="rastreoForm" (ngSubmit)="onSubmitRastreo()">
        <input id="rastreo-hero" type="text" formControlName="numrastreo" autocomplete="off"
               placeholder="Ingresa tu número de rastreo..."/>
        <button type="submit" [disabled]="rastreoForm.invalid">Rastrear →</button>
      </form>
      <div class="tracking-error" *ngIf="rastreoForm.get('numrastreo').invalid && rastreoForm.get('numrastreo').touched">
        Por favor ingrese un número de rastreo válido
      </div>
      <div class="tracking-links">
        <a routerLink="/cotizador" class="t-link">
          <span class="t-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg></span>Cotizar y Enviar
        </a>
        <a routerLink="/cobertura" class="t-link">
          <span class="t-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg></span>Sucursal cercana
        </a>
        <a routerLink="/facturacion" class="t-link">
          <span class="t-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg></span>Buscador Facturas
        </a>
      </div>
    </div>

    <!-- Dots -->
    <div class="slider-dots">
      <button *ngFor="let slide of heroSlides; let i = index"
              class="dot"
              [class.active]="currentSlide === i"
              (click)="goToSlide(i)"
              [attr.aria-label]="'Ir al slide ' + (i + 1)"
              type="button"></button>
    </div>
  </div>
</section>
